import styled from "styled-components";
import { usePrepaymentListDrawer } from "./PrepaymentListDrawerContext";

const PaymentNoButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: #1249bf;
  font-weight: 500;
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;

export function PrepaymentPaymentNoCell({ prepayment, name, notAvailable }) {
  const drawer = usePrepaymentListDrawer();

  if (!name) {
    return notAvailable;
  }

  if (!drawer?.openPayment) {
    return name;
  }

  return (
    <PaymentNoButton
      type="button"
      onClick={event => {
        event.stopPropagation();
        drawer.openPayment(prepayment);
      }}
    >
      {name}
    </PaymentNoButton>
  );
}
